import axios from 'axios';

export default function create(v) {
  return axios.post(`/api/v1/keywords/${v}`);
}
